/* eslint-disable react/prop-types */
import React from 'react'
import axios from 'axios'
import { Link, useHistory } from 'react-router-dom'
import { useUser } from '../contexts/user'
import { useId } from '../contexts/id'

export default function Guest() {
  const { user, setUser, image } = useUser()
  const { sessionId, boardId } = useId()
  const history = useHistory()
  const send = async () => {
    const formData = new FormData()
    if (image) {
      const imageData = await (await fetch(image)).blob()
      formData.append('image', imageData)
    }
    formData.append('name', user.name)
    if (user.email) {
      formData.append('email', user.email)
    }
    if (user.id) {
      formData.append('id', user.id)
    }
    formData.append('boardId', boardId)
    formData.append('sessionId', sessionId)
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }
    axios.post('https://central.dartsee.com/joinSession', formData, config)
    history.push('/success')
  }

  return (
    <>
      <div className="flex flex-col items-center">
        <Link to="/selfie">
          <div className="bg-white h-28 w-28 rounded-full m-4 shadow-lg flex justify-center items-center">
            {!image && (
              <div className="bg-gray-300 h-24 w-24 rounded-full flex items-center justify-center">
                <img className="h-16 opacity-40" src="icon-camera.png" alt="" />
              </div>
            )}
            {image && (
              <img
                className="rounded-full h-24 w-24 object-cover"
                src={image}
              />
            )}
          </div>
        </Link>
        <input
          className="rounded-full px-4 py-2 w-11/12 m-2 shadow-lg"
          type="text"
          value={user.name}
          placeholder="Nickname"
          onChange={(e) => setUser({ ...user, name: e.target.value })}
        />
        <button
          className={`${
            !user.name ? 'bg-gray-400' : 'bg-dartsee-theme-green'
          } rounded-full text-white py-2 w-11/12 uppercase font-semibold m-2`}
          onClick={send}
          disabled={!user.name}
        >
          Join session
        </button>
      </div>
    </>
  )
}
